const CHIME_FREQUENCIES = [880, 1320];
const CHIME_GAP_SECONDS = 0.12;
const CHIME_LENGTH_SECONDS = 0.4;

let sharedContext: AudioContext | null = null;

export function playDoneChime(): void {
  if (typeof AudioContext === 'undefined') return;
  sharedContext ??= new AudioContext();
  const context = sharedContext;
  CHIME_FREQUENCIES.forEach((frequency, index) => {
    const startAt = context.currentTime + index * CHIME_GAP_SECONDS;
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, startAt);
    gain.gain.exponentialRampToValueAtTime(0.2, startAt + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, startAt + CHIME_LENGTH_SECONDS);
    oscillator.connect(gain).connect(context.destination);
    oscillator.start(startAt);
    oscillator.stop(startAt + CHIME_LENGTH_SECONDS);
  });
}
